import React, { useEffect, useState } from 'react';
import { FiCopy, FiTrash2, FiClock, FiExternalLink, FiRefreshCw } from 'react-icons/fi';
import { listSaved, deleteSaved, SavedTranscript } from '../transcribeApi';

function daysLeft(expires: string | null): string {
  if (!expires) return 'no expiry';
  const ms = new Date(expires).getTime() - Date.now();
  if (ms <= 0) return 'expired';
  const d = Math.ceil(ms / 86400000);
  return `${d} day${d === 1 ? '' : 's'} left`;
}

export default function SavedTranscriptsTab() {
  const [rows, setRows] = useState<SavedTranscript[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openId, setOpenId] = useState<number | null>(null);

  const load = () => {
    setLoading(true); setError('');
    listSaved().then(setRows).catch((e) => setError(e?.message || 'Could not load')).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const onDelete = async (id: number) => {
    if (!window.confirm('Delete this saved transcript? This cannot be undone.')) return;
    try { await deleteSaved(id); setRows((r) => r.filter((x) => x.note_id !== id)); }
    catch (e: any) { setError(e?.message || 'Delete failed'); }
  };

  const onCopy = async (t: string) => { try { await navigator.clipboard.writeText(t); } catch { /* noop */ } };

  return (
    <div className="trx-card">
      <div className="trx-result-head">
        <div>
          <strong>Saved transcripts</strong>
          <span className="trx-hint"> · stored in your Knowledge Vault, auto-removed after their retention window</span>
        </div>
        <button className="trx-btn ghost sm" onClick={load}><FiRefreshCw /> Refresh</button>
      </div>

      {loading && <div className="trx-empty">Loading…</div>}
      {error && <div className="trx-error">{error}</div>}
      {!loading && !error && rows.length === 0 && (
        <div className="trx-empty">
          Nothing saved yet. Transcribe something, then <strong>Save to Notes</strong> to keep the text + source link here.
        </div>
      )}

      {!loading && rows.length > 0 && (
        <div className="trx-saved-list">
          {rows.map((r) => (
            <div className="trx-saved" key={r.note_id}>
              <div className="trx-saved-main" onClick={() => setOpenId(openId === r.note_id ? null : r.note_id)}>
                <div className="trx-saved-title">{r.title}</div>
                <div className="trx-saved-meta">
                  <span><FiClock style={{ verticalAlign: -2 }} /> {daysLeft(r.expires_at)}</span>
                  <span>{new Date(r.created_at).toLocaleDateString()}</span>
                  {r.key_takeaway && <span className="trx-saved-take">{r.key_takeaway}</span>}
                </div>
              </div>
              <div className="trx-saved-actions">
                <a className="trx-btn ghost sm" href="/dashboard/vault" title="Open in Knowledge Vault"><FiExternalLink /></a>
                <button className="trx-btn ghost sm" onClick={() => onCopy(r.content_text)} title="Copy"><FiCopy /></button>
                <button className="trx-btn ghost sm danger" onClick={() => onDelete(r.note_id)} title="Delete"><FiTrash2 /></button>
              </div>
              {openId === r.note_id && (
                <pre className="trx-saved-body">{r.content_text}</pre>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
